exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-dashboard {\n  background: lightblue url(\"/assets/img/demo3.PNG\") repeat fixed center;\n  min-height: 100vh;\n  background-size: cover;\n  overflow-y: hidden; }\n\n.border-transparent {\n  border-color: transparent; }\n\n.card.bg-transparent {\n  margin-bottom: 0 !important; }\n\n.row {\n  margin-bottom: 20px !important; }\n\n::ng-deep app-dashboard-filter #exportExcel {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard1/dashboard1.component.scss
// module id = ../../../../../src/app/views/dashboards/dashboard1/dashboard1.component.scss
// module chunks = main